import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";
import type { LoanDto } from "@src/api-new/generated-api.schemas";

export const CREDIT_HISTORY_PAYMENT_MODAL = "CreditHistoryPaymentModal";

export interface FileModalContent {
  modalId?: string;
  title?: string;
  agreement?: string;
  downloadUrl?: string;
  documentName?: string;
  loanId?: number;
}

interface CreditHistoryState {
  loading?: boolean;
  loanHistory?: LoanDto[];
  paymentHistoryDocsLoading?: boolean;
  fileModalContent?: FileModalContent;
  fileModalDownloadInProgress?: boolean;
}

const initialState: CreditHistoryState = {};

const creditHistorySlice = createSlice({
  name: "creditHistory",
  initialState,
  reducers: {
    loanHistoryRequested(state) {
      state.loading = true;
    },
    loanHistorySucceeded(state, action: PayloadAction<LoanDto[]>) {
      state.loanHistory = action.payload;
      state.loading = false;
    },
    loanHistoryFailed(state) {
      state.loanHistory = undefined;
      state.loading = false;
    },
    paymentHistoryDocsRequested(state, action: PayloadAction<number[]>) {
      state.paymentHistoryDocsLoading = true;
    },
    paymentHistoryDocsSucceeded(state) {
      state.paymentHistoryDocsLoading = false;
    },
    paymentHistoryDocsFailed(state) {
      state.paymentHistoryDocsLoading = false;
    },
    openFileModal(state, action: PayloadAction<FileModalContent>) {
      state.fileModalContent = action.payload;
    },
    downloadFileModal(state) {
      state.fileModalDownloadInProgress = true;
    },
    downloadFileModalSuccess(state) {
      state.fileModalDownloadInProgress = false;
    },
    printFileModal(state) {
      return state;
    },
    destroy() {
      return initialState;
    }
  }
});

export default creditHistorySlice.reducer;
export const {
  loanHistoryRequested,
  loanHistorySucceeded,
  loanHistoryFailed,
  paymentHistoryDocsRequested,
  paymentHistoryDocsSucceeded,
  paymentHistoryDocsFailed,
  openFileModal,
  downloadFileModal,
  downloadFileModalSuccess,
  destroy
} = creditHistorySlice.actions;
export const creditHistoryActions = creditHistorySlice.actions;
